import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-time-off-balance-calculations',
  templateUrl: './time-off-balance-calculations.component.html',
  styleUrls: ['./time-off-balance-calculations.component.scss']
})
export class TimeOffBalanceCalculationsComponent implements OnInit {
  @Input() employeeTimeOffType: any;
  @Input() compensation: any;
  @Input() buySellPlanEmployee: any;
  @Input() selectedType: string = 'BUY';
  @Input() hoursInput: number = 0;
  
  constructor() { }

  ngOnInit(): void {
  }

}
